<div class="row m-0">
  <div class="col-12 page-heading-wrapper">
    <gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.booking_details_page_title"
      [displayBacklink]="true" [backLinkText]="'COMMON.BACK' | translate" (back)="routerGoBack()"></gb-ui-page-heading>
  </div>
</div>
<div class="govuk-width-container">
  <div class="row">
    <div class="col-sm-12">
      <ui-stepper [steps]="steps"></ui-stepper>
    </div>
  </div>
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-full">
      <h1>{{datastoreService.pageContent.booking_details_page_subtitle}}</h1>
      <p [innerHTML]="datastoreService.pageContent.booking_details_page_subtitle_body"></p>

      @if (agentMode) {
      <button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
        (click)="datastoreService?.agentRestart()">
        Agent Restart
      </button>
      }

      <hr />

      <div class="govuk-grid-row" id="main-content" tabindex="-1">
        <div class="govuk-grid-column-two-thirds">
          <form [formGroup]="customerDetailsForm">
            <h2 class="govuk-heading-l govuk-heading-l--inverse">
              {{ 'FORM.YOUR_TITLE' | translate }}
            </h2>

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              form.first_name.errors?.required === true && submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="first_name">
                {{ 'COMMON.FIRST_NAME' | translate }}
              </label>

              <p *ngIf="submitted && form.first_name?.errors" id="first-name-error" class="govuk-error-message">
                <span class="govuk-visually-hidden">Error:</span>

                <!-- Required error -->
                <span *ngIf="form.first_name?.errors?.['required']">
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.FIRST_NAME' | translate }
                  }}
                </span>

                <!-- Max length error -->
                <span *ngIf="form.first_name?.errors?.['maxlength']">
                  {{
                  'COMMON.MAX_LENGTH'
                  | translate : {
                  value: 'COMMON.FIRST_NAME' | translate,
                  max: form.first_name.errors?.['maxlength']?.requiredLength
                  }
                  }}
                </span>
              </p>

              <input maxlength="49" aria-required="true" formControlName="first_name"
                class="govuk-input govuk-input--inverse" id="first_name" name="eventName" type="text"
                (change)="radioCopyChange()" [ngClass]="{
              'govuk-input--error':
                form.first_name.errors?.required === true && submitted
            }" />
            </div>

            <!-- <h2 class="mt-1 pb-4">{{'FORM.YOUR_TITLE' | translate}}</h2>
              <div class="govuk-form-group">
                  <label tabindex="0" for="fn"> <span aria-hidden="true" class="form-field-required-marker">
                          *</span> {{'COMMON.FIRST_NAME' | translate}}</label>
                  <input id="fn" type="text" class="form-control" formControlName="first_name" role="textbox">
                  <div *ngIf="submitted && form.first_name.errors" class="invalid-feedback">
                      <div *ngIf="form.first_name.errors?.required" role="alert" tabindex="0">
                          {{ 'COMMON.IS_REQUIRED' | translate: {value: 'COMMON.FIRST_NAME' | translate } }}
                      </div>
                  </div>
              </div> -->

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              form.last_name.errors?.required === true && submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="last_name">
                {{ 'COMMON.LAST_NAME' | translate }}
              </label>

              <p *ngIf="submitted && form.last_name?.errors" id="last-name-error" class="govuk-error-message">
                <span class="govuk-visually-hidden">Error:</span>

                <!-- Required error -->
                <span *ngIf="form.last_name?.errors?.['required']">
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.LAST_NAME' | translate }
                  }}
                </span>

                <!-- Max length error -->
                <span *ngIf="form.last_name?.errors?.['maxlength']">
                  {{
                  'COMMON.MAX_LENGTH'
                  | translate : {
                  value: 'COMMON.LAST_NAME' | translate,
                  max: form.last_name.errors?.['maxlength']?.requiredLength
                  }
                  }}
                </span>
              </p>

              <input maxlength="49" aria-required="true" formControlName="last_name"
                class="govuk-input govuk-input--inverse" id="last_name" name="eventName" type="text"
                (change)="radioCopyChange()" [ngClass]="{
              'govuk-input--error':
                form.last_name.errors?.required === true && submitted
            }" />
            </div>

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              (form.email_address.errors?.required ||
                form.email_address.errors?.pattern) &&
              submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="email_address">
                {{ 'COMMON.EMAIL_ADDRESS' | translate }}
              </label>

              <p *ngIf="submitted && form.email_address?.errors" id="event-name-error" class="govuk-error-message">
                <!-- required -->
                <ng-container *ngIf="form.email_address?.errors?.required">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
                  }}
                </ng-container>
                <!-- pattern -->
                <ng-container *ngIf="form.email_address?.errors?.pattern">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
                  }}
                </ng-container>
              </p>

              <input aria-required="true" formControlName="email_address" class="govuk-input govuk-input--inverse"
                id="email_address" name="eventName" (change)="radioCopyChange()" type="text" [ngClass]="{
              'govuk-input--error':
                form.email_address.errors?.required === true && submitted
            }" />

              <ng-container *ngIf="adminJourney">
                <br />
                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                  <div class="govuk-checkboxes__item">
                    <input aria-required="true" formControlName="email_address_consent" class="govuk-checkboxes__input"
                      id="email_address_consent_box" name="email_address_consent_box" type="checkbox" />

                    <label class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                      for="email_address_consent_box">
                      {{ 'COMMON.ADMIN_EMAIL_HINT' | translate }}
                    </label>
                  </div>
                </div>
                <p class="govuk-error-message" *ngIf="submitted && form.email_address_consent.errors">
                  <span class="govuk-visually-hidden">Error:</span> As we are going
                  to be using email as the point of reminding customers about their
                  ceremony, we really need to ensure that this is correct at the
                  booking.
                </p>
              </ng-container>
            </div>

            <div *ngIf="adminJourney">
              <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                data-module="govuk-notification-banner">
                <div class="govuk-notification-banner__header">
                  <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                    ADMIN GUIDANCE: Email address required
                  </h2>
                </div>
                <div class="govuk-notification-banner__content">
                  <p aria-label="Notification message"
                    class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                    style="font-weight: 500 !important; font-size: 19px !important">
                    {{ 'COMMON.ADMIN_EMAIL_NOTIFICATION' | translate }} <br /><br />
                    {{ 'COMMON.ADMIN_EMAIL_NOTIFICATION_TWO' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Passwords -->
            <!-- <ng-container *ngIf="!adminJourney">
                  <div class="govuk-form-group govuk-password-input" data-module="govuk-password-input" #password>
                      <h3 class="govuk-label-wrapper">
                          <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="email_address">
                              <span aria-hidden="true" class="form-field-required-marker">
                                  *</span> {{'COMMON.PASSWORD' | translate}}
                          </label>
                      </h3>
                      <div id="password-name-hint" class="govuk-hint govuk-hint--inverse">
                          {{'COMMON.PASSWORD_HINT' | translate}}
                      </div>
                      <div id="password-name-hint" class="govuk-hint govuk-hint--inverse">
                          {{'COMMON.PASSWORD_HINT_TWO' | translate}}
                      </div>
                      <p *ngIf="submitted && form.password?.errors" id="event-name-error" class="govuk-error-message">
                          <span *ngIf="form.password?.errors?.passwordInvalid" class="govuk-visually-hidden">Error:</span>
                          {{
                          'COMMON.PASSWORD_PATTERN' | translate}}
                      </p>
                      <div class="govuk-input govuk-input--inverse __wrapper govuk-password-input__wrapper">
                          <input class="govuk-input govuk-input--inverse  govuk-password-input__input govuk-js-password-input-input"
                              id="password-input" formControlName="password" name="password" type="password"
                              spellcheck="false" autocomplete="current-password" autocapitalize="none">
                          <button type="button"
                              class="govuk-button govuk-button--secondary govuk-password-input__toggle govuk-js-password-input-toggle"
                              data-module="govuk-button" aria-controls="password-input" aria-label="Show password" hidden>
                              Show
                          </button>
                      </div>
                  </div>
              </ng-container> -->

            <!-- Passwords end-->

            <div class="govuk-form-group" [ngClass]="{
            'govuk-form-group--error':
              (form.contact_number.errors?.required ||
                form.contact_number.errors?.pattern ||
                form.contact_number.errors?.minlength ||
                form.contact_number.errors?.maxlength) &&
              submitted
          }">

              <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="contact_number">
                {{ 'COMMON.CONTACT_NUMBER' | translate }}
              </label>

              <div id="event-name-hint" class="govuk-hint govuk-hint--inverse">
                {{ 'COMMON.PHONE_HINT' | translate }}
              </div>
              <div id="event-name-hint" class="govuk-hint govuk-hint--inverse">
                {{ 'COMMON.PHONE_HINT_TWO' | translate }}
              </div>
              <p *ngIf="submitted && form.contact_number?.errors" id="event-name-error" class="govuk-error-message">
                <!-- required -->
                <ng-container *ngIf="form.contact_number?.errors?.required">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.IS_REQUIRED'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
                <!-- pattern -->
                <ng-container *ngIf="form.contact_number?.errors?.pattern">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
                <!-- minlength -->
                <ng-container *ngIf="form.contact_number?.errors?.minlength">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
                <!-- maxlength -->
                <ng-container *ngIf="form.contact_number?.errors?.maxlength">
                  <span class="govuk-visually-hidden">Error:</span>
                  {{
                  'COMMON.INVALID'
                  | translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
                  }}
                </ng-container>
              </p>
              <input aria-required="true" formControlName="contact_number" class="govuk-input govuk-input--inverse"
                id="contact_number" name="eventName" (change)="radioCopyChange()"
                (keypress)="keyPressNumberField($event)" type="text" maxlength="15" [ngClass]="{
              'govuk-input--error':
                form.contact_number.errors?.required === true && submitted
            }" />

              <ng-container *ngIf="adminJourney">
                <br />
                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                  <div class="govuk-checkboxes__item">
                    <input aria-required="true" formControlName="contact_number_consent" class="govuk-checkboxes__input"
                      id="contact_number_consent_box" name="contact_number_consent_box" type="checkbox" />

                    <label class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                      for="contact_number_consent_box">
                      {{ 'COMMON.ADMIN_CONTACT_NUMBER_HINT' | translate }}
                    </label>
                  </div>
                </div>
                <p class="govuk-error-message" *ngIf="submitted && form.contact_number_consent.errors">
                  <span class="govuk-visually-hidden">Error:</span> As we are going
                  to be using the contact number as the point of reminding customers
                  about their ceremony, we really need to ensure that this is
                  correct at the booking.
                </p>
              </ng-container>
            </div>

            <!-- <div class="govuk-radios" data-module="govuk-radios">
                  <h3 class="govuk-label-wrapper">
                      <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="contact_number">
                          {{'COMMON.COPY_DETAILS' | translate}}
                      </label>
                  </h3>
                  <div class="govuk-radios" data-module="govuk-radios">
                      <div class="govuk-radios__item">
                          <input formControlName="copyData" (change)="updateRadio(customerDetailsForm,'copyData','Yes')"
                              class="govuk-radios__input" id="Yes" name="copyData" type="radio" value="Yes">
                          <label class="govuk-label govuk-radios__label govuk-radios__label--inverse" for="Yes">
                              Yes
                          </label>
                      </div>
                      <div class="govuk-radios__item">
                          <input formControlName="copyData" (change)="updateRadio(customerDetailsForm,'copyData','No')"
                              class="govuk-radios__input" id="No" name="copyData" type="radio" value="No">
                          <label class="govuk-label govuk-radios__label govuk-radios__label--inverse" for="No">
                              No
                          </label>
                      </div>
                  </div>
              </div> -->

            <!-- Customer questions -->
            <div *ngFor="let question of customerQuestions">
              <!-- questions that arent required -->
              <ng-container *ngIf="!question.required">
                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_field'">

                  <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                    {{ question.name | translate }}
                  </label>

                  <input [attr.aria-required]="question.required ? 'true' : null"
                    formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                    id="{{ question.reference }}" name="{{ question.reference }}" type="text" />
                </div>

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_area'">

                  <label class="govuk-label govuk-label--l" for="more-detail">
                    Can you provide more detail?
                  </label>

                  <div id="more-detail-hint" class="govuk-hint govuk-hint--inverse">
                    Do not include personal or financial information, like your
                    National Insurance number or credit card details
                  </div>
                  <textarea class="govuk-textarea--inverse" id="more-detail" name="moreDetail" rows="5"
                    aria-describedby="more-detail-hint"></textarea>
                </div>


                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                  {{ question.name | translate }}
                </label>


                <input [attr.aria-required]="question.required ? 'true' : null"
                  formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                  id="{{ question.reference }}" name="{{ question.reference }}" type="text" />

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'number'">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [attr.aria-required]="question.required ? 'true' : null" [id]="question.reference"
                    type="search" class="form-control" formControlName="{{ question.reference }}"
                    attr.aria-label="{{ question.name }} input field" (keypress)="keyPressNumberField($event)"
                    maxlength="11" />
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'select') ||
                (question.visible && question.detail_type === 'select-price')
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>

                  <ng-select [attr.aria-required]="question.required ? 'true' : null" [searchable]="false"
                    [clearable]="false" appearance="outline" id="{{ question.reference }}"
                    formControlName="{{ question.reference }}" bindLabel="name" bindValue="name"
                    [items]="question.options" (change)="onQuestionChange()">
                  </ng-select>

                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                question.visible &&
                question.detail_type === 'date' &&
                question.id !== 1
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [id]="question.reference" matInput formControlName="{{ question.reference }}"
                    [matDatepicker]="picker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    [innerHTML]="question.help_text | translateSplit | noSanitise">
                  </span>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      {{ 'COMMON.AGE_VALIDATION' | translate }}
                    </div>
                  </div>
                </div>

                <!-- checkbox -->
                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'check') ||
                (question.visible && question.detail_type === 'check-price')
              ">
                  <mat-checkbox formControlName="{{ question.reference }}" class="" [id]="question.reference">
                    <label tabindex="0" [for]="question.reference"></label>
                    <span *ngIf="question.price == 0">{{ question.name }}</span>

                    <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                      {{ question.price / 100 | currency : 'GBP' : true }}</span>
                  </mat-checkbox>

                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    innerHTML="question.help_text | translateSplit | noSanitise">
                  </span>

                  <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                    class="invalid-feedback">
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: question.name | translateSplit }
                    }}
                  </div>
                  <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                    {{ question?.validation_message }}
                  </div>
                </div>
              </ng-container>

              <!-- questions that are required -->
              <ng-container *ngIf="question.required">
                <div class="govuk-form-group" [ngClass]="{
                'govuk-form-group--error':
                  form[question.reference].errors?.required === true &&
                  submitted
              }" *ngIf="question.visible && question.detail_type === 'text_field'">

                  <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                    {{ question.name | translate }}
                  </label>

                  <p *ngIf="submitted && form[question.reference].errors?.errors" id="event-name-error"
                    class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: question.name | translate }
                    }}
                  </p>
                  <input [attr.aria-required]="question.required ? 'true' : null"
                    formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                    id="{{ question.reference }}" name="{{ question.reference }}" type="text" [ngClass]="{
                  'govuk-input--error':
                    form[question.reference].errors?.required === true &&
                    submitted
                }" />
                </div>

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'text_area'">

                  <label class="govuk-label govuk-label--l" for="more-detail">
                    Can you provide more detail?
                  </label>

                  <div id="more-detail-hint" class="govuk-hint govuk-hint--inverse">
                    Do not include personal or financial information, like your
                    National Insurance number or credit card details
                  </div>
                  <textarea class="govuk-textarea--inverse" id="more-detail" name="moreDetail" rows="5"
                    aria-describedby="more-detail-hint"
                    [attr.aria-required]="question.required ? 'true' : null"></textarea>
                </div>


                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                  {{ question.name | translate }}
                </label>


                <input formControlName="{{ question.reference }}" class="govuk-input govuk-input--inverse"
                  id="{{ question.reference }}" name="{{ question.reference }}" type="text" />

                <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'number'">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [attr.aria-required]="question.required ? 'true' : null" [id]="question.reference"
                    type="search" class="form-control" formControlName="{{ question.reference }}"
                    attr.aria-label="{{ question.name }} input field" (keypress)="keyPressNumberField($event)"
                    maxlength="11" />
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'select') ||
                (question.visible && question.detail_type === 'select-price')
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>

                  <ng-select [attr.aria-required]="question.required ? 'true' : null" [searchable]="false"
                    [clearable]="false" appearance="outline" id="{{ question.reference }}"
                    formControlName="{{ question.reference }}" bindLabel="name" bindValue="name"
                    [items]="question.options" (change)="onQuestionChange()">
                  </ng-select>

                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                  </div>
                </div>

                <div class="govuk-form-group" *ngIf="
                question.visible &&
                question.detail_type === 'date' &&
                question.id !== 1
              ">
                  <label tabindex="0" [for]="question.reference">
                    {{ question.name | translateSplit }}</label>
                  <input [id]="question.reference" matInput formControlName="{{ question.reference }}"
                    [matDatepicker]="picker" readonly />
                  <mat-datepicker-toggle matSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker> </mat-datepicker>
                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    [innerHTML]="question.help_text | translateSplit | noSanitise">
                  </span>
                  <div *ngIf="submitted && form[question.reference].errors" class="invalid-feedback">
                    <div *ngIf="form[question.reference].errors.required" role="alert">
                      {{
                      'COMMON.IS_REQUIRED'
                      | translate : { value: question.name | translateSplit }
                      }}
                    </div>
                    <div *ngIf="form[question.reference].errors.pattern" role="alert">
                      {{ 'COMMON.AGE_VALIDATION' | translate }}
                    </div>
                  </div>
                </div>

                <!-- checkbox -->
                <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'check') ||
                (question.visible && question.detail_type === 'check-price')
              ">
                  <mat-checkbox formControlName="{{ question.reference }}" class="" [id]="question.reference">
                    <label tabindex="0" [for]="question.reference"></label>
                    <span *ngIf="question.price == 0">{{ question.name }}</span>

                    <span tabindex="-1" *ngIf="question.price > 0">{{ question.name }} -
                      {{ question.price / 100 | currency : 'GBP' : true }}</span>
                  </mat-checkbox>

                  <span *ngIf="question.help_text" class="help-text" tabindex="0"
                    innerHTML="question.help_text | translateSplit | noSanitise">
                  </span>

                  <div *ngIf="submitted && form[question.reference].errors?.required" role="alert" tabindex="0"
                    class="invalid-feedback">
                    {{
                    'COMMON.IS_REQUIRED'
                    | translate : { value: question.name | translateSplit }
                    }}
                  </div>
                  <div *ngIf="submitted && form[question.reference].errors?.pattern" role="alert">
                    {{ question?.validation_message }}
                  </div>
                </div>
              </ng-container>
            </div>
            <!-- <br /> -->
          </form>

          <div>
            <form [formGroup]="companyQuestionsForm">
              <div *ngFor="let question of companyQuestions">
                <!-- <pre> {{question.reference}} {{question.detail_type}} = {{question.name}} - {{question.id}} - {{question.detail_type}} - {{question.visible}} - {{ question.conditionals | json }}</pre> -->

                <!-- multiline address lookup -->
                <div [ngClass]="{ 'hidden-question': question.hidden }"
                  *ngIf="question.visible && question.address_lookup_multi_line">
                  <div class="govuk-form-group"
                    [ngClass]="{'govuk-form-group--error': companyQuestionsForm.get('postcode_' + question.reference)?.errors?.invalid_address}">
                    <label class="govuk-label govuk-label--m govuk-label--m--inverse"
                      for="postcode_{{question.reference}}">
                      {{ question.name }}
                    </label>

                    <p *ngIf="companyQuestionsForm.get('postcode_' + question.reference)?.errors?.invalid_address"
                      id="event-name-error" class="govuk-error-message">
                      <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.INVALID_POSTCODE' | translate}}
                    </p>

                    <div *ngIf="companyQuestionsForm.get('postcode_' + question.reference)?.errors?.invalid_address"
                      class="invalid-feedback">
                      <div role="alert">
                        {{ 'COMMON.INVALID_POSTCODE' | translate}}
                      </div>
                    </div>


                    <input [attr.aria-required]="question.required ? 'true' : null"
                      (keydown.space)="$event.preventDefault()" (keydown.spacebar)="$event.preventDefault()"
                      class="govuk-input govuk-input--inverse" id="postcode_{{ question.reference }}"
                      name="postcode_{{ question.reference }}" placeholder="Enter postcode"
                      formControlName="postcode_{{ question.reference }}" type="text" />
                  </div>

                  <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                    [innerHTML]="question.helptext"></div>

                  <button style="margin: 30px 0;" type="button" class="govuk-button--inverse" data-module="govuk-button"
                    (click)="getAddress(question)">
                    {{ 'COMMON.FIND_ADDRESS' | translate }}
                  </button>

                  <div *ngIf="question.addresses">
                    <div class="govuk-form-group" *ngIf="question.addresses.length > 0">
                      <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                        style="color: #0b2265" for="addresses">
                        Select address below
                      </label>
                      <select [attr.aria-required]="question.required ? 'true' : null" (change)="
                      selectSuggestion($event.target.value, question);
                      onQuestionChange()
                    " formControlName="{{ question.reference }}" class="govuk-select govuk-input--inverse"
                        id="addresses" name="addresses">
                        <!-- Hidden placeholder shown only when no value is selected -->
                        <option value="" disabled selected hidden>
                          Select address
                        </option>

                        <ng-container *ngFor="let option of question['addresses']">
                          <option [value]="option.address.UPRN">
                            {{ option.address['full_address'] }}
                          </option>
                        </ng-container>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- single address lookup -->
                <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.address_lookup &&
                !question.address_lookup_multi_line
              ">
                  <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    submitted && bookingForm[question.reference]?.errors
                }">
                    <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                      for="postcode_{{question.reference}}">
                      {{ question.name }}
                    </label>
                    <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                      [form]="bookingForm" [question]="question"></app-form-error-messages>
                    <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                    'govuk-input--error':
                      bookingForm[question.reference].errors && submitted
                  }" (keydown.space)="$event.preventDefault()" (keydown.spacebar)="$event.preventDefault()"
                      class="govuk-input govuk-input--inverse  govuk-input govuk-input--inverse --width-20"
                      id="postcode_{{ question.reference }}" name="postcode_{{ question.reference }}"
                      placeholder="Enter postcode" formControlName="postcode_{{ question.reference }}" type="text" />
                  </div>

                  <button type="button" class="govuk-button govuk-button--inverse" data-module="govuk-button"
                    (click)="getAddress(question)">
                    {{ 'COMMON.FIND_ADDRESS' | translate }}
                  </button>

                  <div *ngIf="question.addresses">
                    <div class="govuk-form-group" [ngClass]="{
                    'govuk-form-group--error':
                      (bookingForm[question.reference].errors?.required ||
                        bookingForm[question.reference].errors?.pattern ||
                        bookingForm[question.reference].errors?.minlength ||
                        bookingForm[question.reference].errors?.maxlength) &&
                      submitted
                  }" *ngIf="question.addresses.length > 0">
                      <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                        style="color: #00703c" for="addresses">
                        Select address below
                      </label>
                      <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                        [form]="bookingForm" [question]="question"></app-form-error-messages>
                      <select [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                      'govuk-select--error':
                        bookingForm[question.reference].errors?.required ===
                          true &&
                        submitted &&
                        submitted
                    }" (change)="
                      validateQuestions($event, question);
                      onQuestionChange();
                      setAddress($event, question)
                    " formControlName="{{ question.reference }}" class="govuk-select" id="addresses" name="addresses">
                        <!-- Hidden placeholder shown only when no value is selected -->
                        <option value="" disabled selected hidden>
                          Select address
                        </option>

                        <ng-container *ngFor="let option of question['addresses']">
                          <option [value]="option.address['ADDRESS']">
                            {{ option.address['ADDRESS'] }}
                          </option>
                        </ng-container>
                      </select>
                    </div>

                    <!-- <div class="govuk-form-group" *ngIf="question.addresses.length > 0">
                                  <label><span *ngIf="question.required" aria-hidden="true"
                                          class="form-field-required-marker">
                                          *</span>Select address below</label>
      
                                  <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                                      id="{{question.reference}}" formControlName="{{question.reference}}"
                                      bindLabel="address.ADDRESS" bindValue="address.ADDRESS" [items]="question.addresses"
                                      (change)="validateQuestions($event, question); onQuestionChange();">
                                  </ng-select>
                              </div> -->
                  </div>
                </div>

                <span [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                !question.address_lookup &&
                !question.address_lookup_multi_line
              ">
                  <!-- select -->
                  <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    submitted && bookingForm[question.reference]?.errors
                }" *ngIf="
                  question.visible &&
                  (question.detail_type === 'select' ||
                    question.detail_type === 'select-price')
                ">
                    <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                      for="{{ question.reference }}">
                      {{ question.name }}
                    </label>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                    <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                      [form]="bookingForm" [question]="question"></app-form-error-messages>
                    <select [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                    'govuk-select--error':
                      bookingForm[question.reference].errors && submitted
                  }" (change)="
                    validateQuestions($event, question); onQuestionChange()
                  " formControlName="{{ question.reference }}" class="govuk-select" id="{{ question.reference }}"
                      name="{{ question.reference }}">
                      <option *ngFor="let option of question.options" [value]="option.name">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>

                  <!-- text field -->
                  <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    submitted && bookingForm[question.reference]?.errors
                }" *ngIf="
                  question.visible && question.detail_type === 'text_field'
                ">

                    <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                      for="{{question.reference}}">
                      {{ question.name }}
                    </label>

                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                    <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                      [form]="bookingForm" [question]="question"></app-form-error-messages>
                    <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                    'govuk-input--error':
                      bookingForm[question.reference].errors && submitted
                  }" class="govuk-input govuk-input--inverse" id="{{question.reference}}" name="eventName" type="text"
                      formControlName="{{ question.reference }}" (input)="
                    validateQuestions($event, question); onQuestionChange()
                  " />
                  </div>

                  <!-- text area -->
                  <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    submitted && bookingForm[question.reference]?.errors
                }" *ngIf="question.visible && question.detail_type === 'text_area'">

                    <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                      for="{{ question.reference }}">
                      {{ question.name }}
                    </label>

                    <div id="{{ question.reference }}-hint" class="govuk-hint govuk-hint--inverse">
                      {{ question.helptext }}
                    </div>
                    <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                      [form]="bookingForm" [question]="question"></app-form-error-messages>
                    <textarea [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                    'govuk-input--error':
                      bookingForm[question.reference].errors && submitted
                  }" formControlName="{{ question.reference }}" class="govuk-textarea--inverse"
                      id="{{ question.reference }}" name="moreDetail" rows="5" (input)="
                    validateQuestions($event, question); onQuestionChange()
                  "></textarea>
                  </div>

                  <!-- /////////////////////////////////////////// -->
                  <div *ngIf="question.visible && question.detail_type === 'date'" class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    bookingForm[question.reference].errors?.required ||
                    bookingForm[question.reference].errors?.pattern ||
                    bookingForm[question.reference].errors?.minlength ||
                    bookingForm[question.reference].errors?.maxlength ||
                    bookingForm[question.reference].errors?.pastDate ||
                    bookingForm[question.reference].errors?.futureDate
                }">
                    <fieldset class="govuk-fieldset" role="group" [attr.aria-describedby]="question.id">
                      <legend
                        class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse">
                        <h3 class="govuk-fieldset__heading">
                          {{ question.name }}
                        </h3>
                      </legend>
                      <div id="{{ question.id }}" class="govuk-hint govuk-hint--inverse" *ngIf="question.helptext"
                        [innerHTML]="question.helptext"></div>
                      <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                        [form]="bookingForm" [question]="question"></app-form-error-messages>
                      <div class="govuk-date-input" id="passport-issued">
                        <div class="govuk-date-input__item">
                          <div class="govuk-form-group">
                            <label class="govuk-label govuk-date-input__label" for="{{ question.id }}_d">
                              Day
                            </label>
                            <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                            'govuk-input--error':
                              bookingForm[question.reference].errors &&
                              submitted
                          }" (change)="
                            validateQuestions($event, question);
                            onQuestionChange()
                          " class="govuk-input govuk-input--inverse  govuk-date-input__input govuk-input govuk-input--inverse --width-2"
                              id="{{ question.id }}_d" name="{{ question.id }}_d" type="text" inputmode="numeric" />
                          </div>
                        </div>
                        <div class="govuk-date-input__item">
                          <div class="govuk-form-group">
                            <label class="govuk-label govuk-date-input__label" for="{{ question.id }}_m">
                              Month
                            </label>
                            <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                            'govuk-input--error':
                              bookingForm[question.reference].errors &&
                              submitted
                          }" (change)="
                            validateQuestions($event, question);
                            onQuestionChange()
                          " class="govuk-input govuk-input--inverse  govuk-date-input__input govuk-input govuk-input--inverse --width-2"
                              id="{{ question.id }}_m" name="{{ question.id }}_m" type="text" inputmode="numeric" />
                          </div>
                        </div>
                        <div class="govuk-date-input__item">
                          <div class="govuk-form-group">
                            <label class="govuk-label govuk-date-input__label" for="{{ question.id }}_y">
                              Year
                            </label>
                            <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                            'govuk-input--error':
                              bookingForm[question.reference].errors &&
                              submitted
                          }" (change)="
                            validateQuestions($event, question);
                            onQuestionChange()
                          " class="govuk-input govuk-input--inverse  govuk-date-input__input govuk-input govuk-input--inverse --width-4"
                              id="{{ question.id }}_y" name="{{ question.id }}_y" type="text" inputmode="numeric" />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <!-- GOVUK radio -->
                  <div *ngIf="
                  question.visible &&
                  (question.detail_type === 'radio' ||
                    question.detail_type === 'radio-price')
                " class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    submitted && bookingForm[question.reference]?.errors
                }">
                    <fieldset [attr.aria-required]="question.required ? 'true' : null" class="govuk-fieldset"
                      [attr.aria-describedby]="question.helptext ? 'changedName-hint-' + question.reference : null">
                      <legend
                        class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse">
                        {{ question.name }}
                      </legend>
                      <div id="changedName-hint-{{question.reference}}" class="govuk-hint govuk-hint--inverse"
                        *ngIf="question.helptext" [innerHTML]="question.helptext"></div>

                      <div class="govuk-radios" data-module="govuk-radios">
                        <div class="govuk-radios__item" *ngFor="let option of question.options">
                          <input [ngClass]="{
                          'govuk-input--error':
                            bookingForm[question.reference].errors && submitted
                        }" formControlName="{{ question.reference }}" (change)="
                          updateRadio(
                            companyQuestionsForm,
                            question.reference,
                            option.name
                          )
                        " class="govuk-radios__input"
                            id="{{ question.reference + '_' + option.name.split(' ').join('') }}"
                            [attr.name]="question.reference" type="radio" [value]="option.name" />
                          <label class="govuk-label govuk-radios__label govuk-radios__label--inverse"
                            for="{{ question.reference + '_' + option.name.split(' ').join('') }}">
                            {{ option.name }}
                          </label>
                        </div>
                      </div>
                      <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                        [form]="bookingForm" [question]="question"></app-form-error-messages>
                    </fieldset>
                  </div>

                  <!--CHECKBOX-->
                  <div class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    submitted && bookingForm[question.reference]?.errors
                }" *ngIf="question.visible && question.detail_type === 'check'">
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                    <app-form-error-messages [submitted]="submitted" [formGroup]="companyQuestionsForm"
                      [form]="bookingForm" [question]="question"></app-form-error-messages>
                    <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                      <div class="govuk-checkboxes__item">
                        <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                        'govuk-input--error':
                          bookingForm[question.reference].errors && submitted
                      }" (change)="
                        validateQuestions($event, question);
                        onQuestionChange()
                      " class="govuk-checkboxes__input" id="{{ question.id }}" name="{{ question.id }}" type="checkbox"
                          formControlName="{{ question.id }}" />
                        <label class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                          for="{{ question.id }}">
                          {{ question.name }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- normal heading-->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  !question.conditionals.component_type
                ">
                    <p [ngStyle]="{ color: question.customLabelColour }">
                      <b>{{ question.name }}</b>
                    </p>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>

                  <!-- inset heading -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'inset_text'
                ">
                    <div class="govuk-inset-text" [innerHTML]="addHyperlinks(question.name)">
                    </div>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>

                  <!-- body component -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'body'
                ">
                    <div id="{{ question.id }}" [innerHTML]="addHyperlinks(question.conditionals.component_text)"></div>
                  </div>

                  <!-- govbook info box -->
                  <wcc-info-box [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'wcc-information_box'"
                    [content]="addHyperlinks(question.conditionals.component_text)">
                  </wcc-info-box>

                  <wcc-warning-box [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
              question.visible &&
              question.detail_type === 'heading' &&
              question.conditionals.component_type === 'wcc-warning_box'" [question]="{
              component_text: question.conditionals.component_text
            }" [returnConfig]="returnConfig"></wcc-warning-box>

                  <!-- details component type -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'details'
                ">
                    <details class="govuk-details">
                      <summary class="govuk-details__summary">
                        <span class="govuk-details__summary-text">
                          {{ question.name }}
                        </span>
                      </summary>
                      <div class="govuk-details__text" [innerHTML]="addHyperlinks(question.conditionals.component_text)"></div>
                    </details>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>

                  <!-- notifcation banner heading -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'notification_banner'
                ">
                    <div class="govuk-notification-banner" role="region"
                      aria-labelledby="govuk-notification-banner-title" data-module="govuk-notification-banner">
                      <div class="govuk-notification-banner__header">
                        <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                          {{ question.name }}
                        </h2>
                      </div>
                      <div class="govuk-notification-banner__content">
                        <p class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                          [innerHTML]="addHyperlinks(question)"></p>
                      </div>
                    </div>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>

                  <!-- warning heading -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'warning_text'
                ">
                    <div class="govuk-warning-text">
                      <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                      <strong class="govuk-warning-text__text">
                        <span class="govuk-visually-hidden">Warning</span>
                        {{ question.name }}
                      </strong>
                    </div>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>

                  <!-- panel heading -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'panel'
                ">
                    <div class="govuk-panel govuk-panel--confirmation">
                      <h3 class="govuk-panel__title">
                        {{ question.name }}
                      </h3>
                      <div class="govuk-panel__body" [innerHTML]="addHyperlinks(question)"></div>
                    </div>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>

                  <!-- heading 2 -->
                  <div [ngClass]="{ 'hidden-question': question.hidden }"
                    *ngIf="question.visible && question.detail_type === 'heading_2'">
                    <h2 class="govuk-heading-l govuk-heading-l--inverse"
                      [ngStyle]="{ color: question.customLabelColour }">
                      {{ question.name }}
                    </h2>
                    <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                      [innerHTML]="question.helptext"></div>
                  </div>
                </span>
              </div>
            </form>
          </div>

          <!-- <form [formGroup]="customerDetailsForm" autocomplete="off"> -->
          <!--  terms and conditions -->
          <!-- <div class="govuk-form-group" [ngClass]="{'govuk-form-group--error': submitted && form.tnc.errors }">
                  <fieldset class="govuk-fieldset" aria-describedby="tnc">
                      <legend class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse">
                          <h3 class="govuk-heading-l govuk-heading-l--inverse">
                              {{'FORM.TNCS.TNCS_TITLE' | translate}}
                          </h3>
                      </legend>
                      <p class="govuk-error-message" *ngIf="submitted && form.tnc.errors">
                          <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate }}
                      </p>
                      <div id="tnc" class="govuk-hint govuk-hint--inverse" [innerHTML]="tncPolicy">
                      </div>
                      <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                          <div class="govuk-checkboxes__item">
                              <input formControlName="tnc" class="govuk-checkboxes__input" id="tncPolicy" name="tncPolicy"
                                  type="checkbox" value="carcasses">

                              <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label" for="tncPolicy">
                                  {{'COMMON.POLICY_AGREE' | translate}}
                              </label>

                              <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label" for="tncPolicy">
                                  {{'COMMON.POLICY_AGREE_ADMIN' | translate}}
                              </label>

                          </div>
                      </div>
                  </fieldset>
              </div> -->

          <!--  service terms -->
          <!-- <div class="govuk-form-group"
                  [ngClass]="{'govuk-form-group--error': submitted && form.service_policy.errors }">
                  <fieldset class="govuk-fieldset" aria-describedby="service_policy">
                      <p class="govuk-error-message" *ngIf="submitted && form.service_policy.errors">
                          <span class="govuk-visually-hidden">Error:</span> {{ 'COMMON.IS_REQUIRED' | translate }}
                      </p>
                      <div id="service_policy" class="govuk-hint govuk-hint--inverse" [innerHTML]="servicePolicy">
                      </div>
                      <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                          <div class="govuk-checkboxes__item">
                              <input formControlName="service_policy" class="govuk-checkboxes__input" id="service_policy"
                                  name="service_policy" type="checkbox" value="carcasses">

                              <label *ngIf="!adminJourney" class="govuk-label govuk-checkboxes__label"
                                  for="service_policy">
                                  {{'COMMON.POLICY_AGREE' | translate}}
                              </label>

                              <label *ngIf="adminJourney" class="govuk-label govuk-checkboxes__label"
                                  for="service_policy">
                                  {{'COMMON.POLICY_AGREE_ADMIN' | translate}}
                              </label>

                          </div>
                      </div>
                  </fieldset>
              </div> -->

          <!-- <div
          class="govuk-form-group"
          [ngClass]="{
            'govuk-form-group--error': submitted && form.data_policy.errors
          }"
        >
          <fieldset class="govuk-fieldset" aria-describedby="data_policy">
            <legend
              class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
            >
              <h3 class="govuk-heading-l govuk-heading-l--inverse">
                {{ 'COMMON.DATA_POLICY' | translate }}
              </h3>
            </legend>
            <p
              class="govuk-error-message"
              *ngIf="submitted && form.data_policy.errors"
            >
              <span class="govuk-visually-hidden">Error:</span>
              {{ 'COMMON.IS_REQUIRED' | translate }}
            </p>
            <div
              id="data_policy"
              class="govuk-hint govuk-hint--inverse"
              [innerHTML]="dataPolicy"
            ></div>
            <div class="govuk-checkboxes" data-module="govuk-checkboxes">
              <div class="govuk-checkboxes__item">
                <input
                  formControlName="data_policy"
                  class="govuk-checkboxes__input"
                  id="datapolicy"
                  name="datapolicy"
                  type="checkbox"
                  value="carcasses"
                />

                <label
                  *ngIf="!adminJourney"
                  class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                  for="datapolicy"
                >
                  {{ 'COMMON.POLICY_AGREE' | translate }}
                </label>

                <label
                  *ngIf="adminJourney"
                  class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                  for="datapolicy"
                >
                  {{ 'COMMON.POLICY_AGREE_ADMIN' | translate }}
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </form> -->

        </div>

        <div class="govuk-grid-column-one-third no-mobile">
          <app-booking-summary></app-booking-summary>
        </div>

        <div class="govuk-grid-column-two-thirds">
          <div class="row pb-4">
            <div class="col-sm-12">
              <button type="submit" class="govuk-button govuk-button--inverse" data-module="govuk-button"
                (click)="onSubmit()">
                {{ 'COMMON.NEXT' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>